const relationship = {
	spouse: "SPOUSE",
	// son: "SON",
	child: "CHILD",
	// daughter: "DAUGHTER",
	stepchild: "STEP CHILD",
	court_ordered_dependent: "COURT-ORDERED DEPENDENT",
	legal_custody_child: "LEGAL CUSTODY CHILD",
	disabled_child: "DISABLED CHILD",
	grandchild: "GRANDCHILD",
	others: "OTHERS"
};

export const RELATIONSHIP = relationship;
